import React from 'react';
import './ExportButton.css';

function ExportButton({ onExport, dataCount }) {
  return (
    <div className="export-section">
      <div className="export-card">
        <div className="export-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <path d="M9 15h6" />
          </svg>
        </div>
        <div className="export-content">
          <h3>Prêt à exporter</h3>
          <p>{dataCount} entrée{dataCount > 1 ? 's' : ''} prête{dataCount > 1 ? 's' : ''} à être exportée{dataCount > 1 ? 's' : ''} vers Excel</p>
        </div>
        <button className="export-button" onClick={onExport}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Exporter Excel
        </button>
      </div>
    </div>
  );
}

export default ExportButton;
